// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class InfoWindowItem {
    constructor(id) {
        this.id = -1;
        this.isVisible = true;
        this.label = '';
        this.formattedValues = [''];
        this.id = id;
    }
}
